<template>
  <div class="HelloDetails">
    <img :src="helloImage" />
    <p>{{ helloDescription }}</p>
  </div>
</template>

<script>
export default {
  props: {
    helloImage: String,
    helloDescription: String,
  },
};
</script>

<style scoped>
img {
  /* width: 168px */
  height: 112.04px;
}
p {
  /* height: 79px; */
  margin-top: 20px;
  max-width: 199px;
  color: #fff;
  font-size: 20px;
  line-height: 26px;
}
@media screen and (max-width:720px){
  img {
  /* width: 168px */
  height: 40px;
}
p {
  font-size: 18px;
  line-height: 26px;
}
}
</style>